export const clientId = 'd94cfe06099aea946cd8';
export const clientSecret = '8673febb00d9ec3fe1c6d9259c87786af3808dc6';
